import { useEffect, useState } from "react";


import { useHistory } from "react-router-dom";

import { CCol, CContainer, CRow } from "@coreui/react";
import Loading from "../indicators/Loading";

const RecordSearch = () => {

  const [sidebarColor, setSidebarColor] = useState("#222d32");
  const [sidebarWidth, setSidebarWidth] = useState("54px");
  const [showHeaderRight, setShowHeaderRight] = useState(true);
  const [search, setSearch] = useState<string>("");
  const [loading, setLoading] = useState(false);

  const history = useHistory();


  const onSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(e.target.value);
  };

  const onSearch = () => {
    if (search.trim() !== "") {
      setLoading(true);
      setTimeout(() => {
        history.push(`/search/${search.trim()}`);
        setLoading(false);
      }, 500);
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === "Enter") {
      onSearch();
    }
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768){
        setSidebarColor("#ffffff");
        setSidebarWidth("0");
        setShowHeaderRight(false);
      } else {
        setSidebarColor("#222d32");
        setSidebarWidth("54px")
        setShowHeaderRight(true);
      }
       
    };

    handleResize(); 
    window.addEventListener("resize", handleResize); 

    return () => window.removeEventListener("resize", handleResize); 
  }, []);

  if (loading) {
    return <Loading />;
  }

  return (
    <div style={{ fontFamily: "Myanmar Text, sans-serif", backgroundColor: "#ffffff", height: "100vh", display: "flex", flexDirection: "column" }}>
      <header
    style={{
      backgroundColor: "#004080",
      color: "white",
      height: "60px",
      width: "100%",
      padding: "0 20px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    }}
  >
    <div>
      <img
        src="/dnalogo2022.png"
        alt="Logo"
        style={{ height: "50px", marginRight: "10px" }}
      />
    </div>

    
    {showHeaderRight?<div
      style={{
        position: "relative",
        flex: 1,
        marginLeft: "auto",
        marginRight: "20px",
        maxWidth: "300px",
      }}
    >
      <input
        type="text"
        placeholder="Buscar..."
        style={{
          padding: "5px 30px 5px 10px",
          borderRadius: "5px",
          border: "1px solid white",
          backgroundColor: "#004080",
          color: "white",
          width: "100%",
        }}
        onKeyDown={handleKeyDown}
        onChange={onSearchChange}
        value={search}
      />
      <i
        className="fas fa-search"
        style={{
          position: "absolute",
          right: "10px",
          top: "50%",
          transform: "translateY(-50%)",
          color: "white",
        }}
        onClick={onSearch}
      ></i>
    </div>:<div></div>}

    <div>
      <span style={{ marginRight: "10px" }}>ANÓNIMO</span>
      <i className="fas fa-chevron-down"></i>
    </div>
  </header>
      <div>
        <aside
          style={{
            width: sidebarWidth,
            backgroundColor: sidebarColor,
            position: "fixed",
            top: "60px", 
            bottom: "0",
          }}
        ></aside>

        <main 
          style={{
            marginLeft: sidebarWidth,
            marginTop: "20px",
            backgroundColor: "#ffffff",
            flexGrow: 1,
            display:"flex",
          }}
        >
          <CContainer style={{
              width: "100%", 
              margin: "0 auto",
            }}>
            <CRow>
              <CCol>
                <strong>Resultados</strong>
                <p><a href="#">No se encontraron resultados</a></p>
              </CCol>
            </CRow>
          </CContainer>
        </main>
      </div>
    </div>
  );
};

export default RecordSearch;
